












import { Authorisers } from "@timesheets/routes-api-common";
import { getSummaryRoleComponentSelectorMixin } from "Components/Summary/SummaryRoleComponentSelector/getSummaryRoleComponentSelectorMixin";
import { PropOptions } from "vue";

const base = getSummaryRoleComponentSelectorMixin(Authorisers.All);

export default base.extend({
  name: "AuthorisersSummaryRoleComponentSelector",

  props: {
    contractorId: {
      type: String,
      required: false,
    } as PropOptions<string | undefined>,
  },

  components: {
    AuthorisingRole: () => import("./Summary/AuthorisingRole/Index.vue"),
    ContractingRole: () => import("./Summary/ContractingRole/Index.vue"),
    RecruitmentAgencyAdministrationRole: () => import("./Summary/RecruitmentAgencyAdministrationRole/Index.vue"),
  },
});
